import { ImageCart } from "@/Components/Images/ImagesCart/ImageCart";
import { QuantityCartv2 } from "@/Components/Index";
import ModalError from "@/Components/Modal/ModalError";
import ModalViewData from "@/Components/Modal/ModalViewDetail/ModalViewData";
import Tables from "@/Components/Table/Tables";
import TBody from "@/Components/Table/TBody/TBody";
import THeader from "@/Components/Table/THeader/THeader";
import { useContextCheckoutData } from "@/Context/Checkout/ContextCheckoutProvider";
import { useContextTicketProvider } from "@/Context/Ticket/ContextTicketCartProvider";
import { useCartLimit } from "@/Hooks/AlertLimit/useCartLimit";
import { formatMX } from "@/Utils/Fomat.price";
import { useCallback, useState } from "react";
import { Link } from "react-router-dom";

const ListMyCart = () => {
  const { DeleteCart, taskCart, UpdateCountCart } = useContextCheckoutData();
  const { UpdateQuantity, DeleteTicketCart } = useContextTicketProvider();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [viewDetilModal, setViewDetilModal] = useState<boolean>(false);
  const [SkuID, setSkuId] = useState<string>("");
  const { cartLimitItem, saveCartLimit, clearCartLimit } = useCartLimit();

  const headdleAddQuantity = useCallback((Count: number, IdSku?: string) => {
    const data = taskCart?.find((d) => d.IdSKU === IdSku);

    //verificamos si existe el dato antes de agregarlo
    if (cartLimitItem?.Sku === IdSku) clearCartLimit();

    //se agrega nuevamente al articulo.
    if (Count >= (data?.LimitQuantity ?? 0)) {
      setShowModal(true);
      saveCartLimit({
        ImageProduct: data?.ImageProduct ?? "",
        TitleProduct: data?.TitleProduct ?? "",
        LimitQuantity: data?.LimitQuantity ?? 0,
        Sku: IdSku!,
      });
    }
    //Modificamos la cantidad que se desea llevar el cliente / usuario
    UpdateCountCart(IdSku!, Count);
    UpdateQuantity(IdSku!, Count);
  }, []);

  const headdlessDeleteCart = useCallback((IdSku: string) => {
    //eliminamos del carrito de compras
    DeleteCart(IdSku);
    //eliminamos del carrito de ticket
    DeleteTicketCart(IdSku);
  }, []);

  const headdlesModal = (id: string) => {
    setViewDetilModal(true);
    setSkuId(id);
  };

  return (
    <>
      <div className="table-responsive">
        <Tables classNames="table ps-table--shopping-cart ps-table--responsive">
          <THeader>
            <th scope="col">NOMBRE</th>
            <th scope="col">PRECIO</th>
            <th scope="col">CANTIDAD</th>
            <th scope="col">TOTAL</th>
            <th scope="col"></th>
          </THeader>
          <TBody>
            {taskCart.length > 0 ? (
              taskCart.map((item) => (
                <tr key={item.IdSKU}>
                  <td data-label="Product">
                    <div className="ps-product--cart">
                      <div className="ps-product__thumbnail d-block">
                        <Link
                          //to={`/Electrónicav2/${item.Categories}/${item.SubCategories}/article/storeId/${item.IdSKU}/c`}>
                          to={"#"}
                          onClick={() => headdlesModal(item.IdSKU)}>
                          <ImageCart
                            srcx={item.ImageProduct}
                            altx={item.TitleProduct}
                          />
                        </Link>
                      </div>
                      <div className="ps-product__content">
                        <Link
                          //to={`/Electrónicav2/${item.Categories}/${item.SubCategories}/article/storeId/${item.IdSKU}/c`}
                          to={"#"}
                          onClick={() => headdlesModal(item.IdSKU)}>
                          {item.TitleProduct}
                        </Link>
                        <p>
                          Limite :<strong> {item.LimitQuantity}</strong>
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="price" data-label="Price">
                    ${formatMX(item.PriceProduct)}
                  </td>
                  <td data-label="Quantity">
                    <QuantityCartv2
                      clickQuantity={headdleAddQuantity}
                      idSku={item.IdSKU ?? ""}
                      valuesData={item.Quantity ?? 0}
                      isDisabled={
                        (item.Quantity ?? 0) >= (item.LimitQuantity ?? 0)
                          ? true
                          : false
                      }
                    />
                  </td>
                  <td data-label="Total">
                    $
                    {formatMX(
                      (item.PriceTotal ?? 0) === 0
                        ? (item.PriceProduct ?? 0) * (item.Quantity ?? 0)
                        : item.PriceTotal ?? 0
                    )}
                  </td>
                  <td data-label="Actions">
                    <Link
                      to={""}
                      onClick={() => headdlessDeleteCart(item.IdSKU)}>
                      <i className="icon-cross"></i>
                    </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="text-center table-light">
                  <h3 className="develop___text">
                    Tu carrito está esperando, ¡es hora de llenarlo! <br />{" "}
                  </h3>
                  <p style={{ fontSize: "20px" }} className="develop___text">
                    Explora los productos que tener para tí{" "}
                  </p>
                </td>
              </tr>
            )}
          </TBody>
        </Tables>
      </div>
      {showModal && (
        <ModalError
          nameP={cartLimitItem?.TitleProduct ?? ""}
          srcP={cartLimitItem?.ImageProduct ?? ""}
          limitCompra={cartLimitItem?.LimitQuantity ?? 0}
          showModal={showModal}
          setShowModal={setShowModal}
        />
      )}
      {viewDetilModal && (
        <ModalViewData
          viewModal={viewDetilModal}
          setViewModal={setViewDetilModal}
          //Products={Productos?.filter((x) => x.Id === id) ?? []}
          id={
            taskCart.filter((w) => w.IdSKU === SkuID).map((f) => f.IdSKU)[0] ??
            ""
          }
          category={
            taskCart
              .filter((w) => w.IdSKU === SkuID)
              .map((f) => f.Categories)[0] ?? ""
          }
          subcategory={
            taskCart
              .filter((w) => w.IdSKU === SkuID)
              .map((f) => f.SubCategories)[0] ?? ""
          }
          //heanddleAddCart={heanddleAddCart}
          viewButton={false}
        />
      )}
    </>
  );
};

export default ListMyCart;
